'use client';

import Image from 'next/image';
import NewsletterForm from '../../Support/newsletterForm';
import PopularPosts from './PopularPosts';

export default function ArticleSidebar({ currentId, t }) {
  return (
    <aside className="single-blog-v2-sidebar">
      <section className="single-blog-v2-newsletter">
        <div className="single-blog-v2-newsletter-image">
          <Image
            src="/assets/img/blog/blog_news_letter.png"
            alt=""
            fill
            sizes="320px"
          />
        </div>
        <div className="single-blog-v2-newsletter-copy">
          <span className="blog-v2-featured-label">{t('blog:singleLayout2.newsletterEyebrow')}</span>
          <h2>{t('blog:singleLayout2.newsletterTitle')}</h2>
          <p>{t('blog:singleLayout2.newsletterText')}</p>
          <NewsletterForm />
        </div>
      </section>
      <div className="single-blog-v2-popular">
        <PopularPosts title={t('blog:popularPosts')} currentId={currentId} max={12} />
      </div>
    </aside>
  );
}
